module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/顶部修饰图.de63718d.png";